import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {makeGetConversationSelection} from '../../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {makeGetIsPanelPopup} from '../../../store/panels/panelsSelectors';
import {CellsPanelId, ViewerPanelId} from '../../../store/panels/panelStateBase';
import {ViewerPanelPageState} from '../../../store/panels/viewer/viewerPanelState';
import {Viewer} from './viewer';

/*
 * Props.
 */

interface ViewerContainerProps {
  cellsPanelId: CellsPanelId | undefined;
  panelId: ViewerPanelId;
  contentPage: ViewerPanelPageState;
  shouldFocusComment?: boolean;
}

/*
 * Selectors.
 */

function getCellsPanelId(_state: unknown, props: ViewerContainerProps) {
  return props.cellsPanelId;
}

function getPanelId(_state: unknown, props: ViewerContainerProps) {
  return props.panelId;
}

function getContentParameters(_state: unknown, props: ViewerContainerProps) {
  return props.contentPage.parameters;
}

function makeGetContentConversationSelection() {
  return makeGetConversationSelection(getContentParameters, getCellsPanelId);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ViewerContainerProps>()(() => ({
  isInPopup: makeGetIsPanelPopup(getPanelId),
  contentConversationSelection: makeGetContentConversationSelection(),
}));

export const ViewerContainer = connect(mapStateToProps)(Viewer);
